import convict from 'convict';
import { ServerConfig } from './ServerConfig';
import { clientConfigSchema } from './clientConfigSchema';

export type ServerConfigSchema = convict.Schema<ServerConfig>;

export const serverConfigSchema: ServerConfigSchema = {
    ...clientConfigSchema,
    firebase: {
        ...clientConfigSchema.firebase,
        serviceAccount: {
            format: String,
            default: null,
            env: 'FIREBASE_ADMIN_CERT',
        },
    },

    rentalsApi: {
        ...clientConfigSchema.rentalsApi,
        accountKey: {
            format: String,
            default: null,
            env: 'NEXT_PUBLIC_RENTALS_API_ACCOUNT_KEY',
        },
    },
    auth0: {
        baseURL: {
            format: String,
            default: null,
            env: 'NEXT_PUBLIC_APP_URL',
        },
        baseURLStar: {
            format: String,
            default: null,
            env: 'NEXT_PUBLIC_STAR_APP_URL',
        },
        clientID: {
            format: String,
            default: null,
            env: 'AUTH0_CLIENT_ID',
        },
        claimsNamespace: {
            format: String,
            default: null,
            env: 'AUTH0_CLAIMS_NAMESPACE',
        },
        issuerBaseURL: {
            format: String,
            default: null,
            env: 'AUTH0_ISSUER_BASE_URL',
        },
        secret: {
            format: String,
            default: null,
            env: 'AUTH0_SECRET',
        },
        clientSecret: {
            format: String,
            default: null,
            env: 'AUTH0_CLIENT_SECRET',
        },
    },
    auth0Management: {
        domain: {
            format: String,
            default: null,
            env: 'AUTH0_MANAGEMENT_DOMAIN',
        },
        clientId: {
            format: String,
            default: null,
            env: 'AUTH0_MANAGEMENT_CLIENT_ID',
        },
        clientSecret: {
            format: String,
            default: null,
            env: 'AUTH0_MANAGEMENT_CLIENT_SECRET',
        },
    },
    mandrill: {
        apiKey: {
            format: String,
            default: null,
            env: 'MANDRILL_API_KEY',
        },
        confirmEmailTemplate: {
            format: String,
            default: null,
            env: 'MANDRILL_CONFIRM_EMAIL_TEMPLATE',
        },
    },
    kariba: {
        projectId: {
            format: String,
            default: null,
            env: 'NEXT_KARIBA_PROJECT_ID',
        },
    },
    jucyCache: {
        apiKey: {
            format: String,
            default: '',
            env: 'JUCY_CACHE_API_KEY',
        },
    },
};
